import digitalData from '~/common/services/data-layer-service';

export function dataLayerPushRYIForm(
  formName: string,
  model: string,
  user: Record<string, string>,
  externalLeadId?: string
) {
  digitalData.push({
    event: '_formNavigate',
    form: {
      name: formName,
      stage: 'submitted',
      details: {
        ...(externalLeadId ? { externalLeadId } : {}),
        vehicleSelected: [
          {
            make: 'Subaru',
            model,
          },
        ],
      },
    },
    user,
  });
}
